import React from 'react';
import HeadLink from '../../atoms/HeadLink';

const Manifest = () => {
  return <HeadLink rel="manifest" href="/site.webmanifest" />;
};

export default Manifest;
